export enum CryptocurrencyAdditionalDataType {
    None = 1,
    Tag = 2,
    MEMO = 3
}